import { render } from "./funList.vue?vue&type=template&id=476c8864&scoped=true"
import script from "./funList.vue?vue&type=script&lang=js"
export * from "./funList.vue?vue&type=script&lang=js"

import "./funList.vue?vue&type=style&index=0&id=476c8864&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-476c8864"

export default script